module.exports = __webpack_public_path__ + "static/home_icon-c3fe2a98d596e3970b1614eace3e7125.png";